export default () => {
  // Handler that uses various data-* attributes to trigger
  // specific actions, mimicing bootstraps attributes
  // const triggers = Array.from(document.querySelectorAll('[data-toggle="collapse"]'))

  window.addEventListener(
    "click",
    e => {
      const el = e.target.closest('[data-toggle="collapse"]')
      if (el) {
        e.preventDefault()
        const selector = el.getAttribute("data-target")
        collapse(el, selector, "toggle")
      }
    },
    false
  )

  const fnmap = {
    toggle: "toggle",
    show: "add",
    hide: "remove",
  }

  const collapse = (triggerEl, selector, cmd) => {
    triggerEl.classList.toggle("active")
    const textNode = triggerEl.querySelector("[data-collapse-text]")
    if (textNode) {
      const text = textNode.innerText
      textNode.innerText = textNode.getAttribute("data-collapse-text")
      textNode.setAttribute("data-collapse-text", text)
    }

    const targets = Array.from(document.querySelectorAll(selector))
    targets.forEach(target => {
      target.classList[fnmap[cmd]]("show")
    })
  }
}
